export const MICROAPPFAKEDATABASE = {
    microappSecurityTree: {
        'home': {
            'access': {
                'USER': true,
                'ADMIN': true,
            }
        }
    }
}